import * as React from 'react';
import { IconProps, SIZE_MAP } from '../types';
import { cn } from '../../../utils/cn';

const ChevronDownIcon = ({ size = 'lg', className, ...props }: IconProps) => {
  const px = SIZE_MAP[size];

  return (
    <svg
      width={px}
      height={px}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn('text-primary', className)}
      {...props}
    >
      <path
        d="M17.4697 8.71967C17.7626 8.42678 18.2373 8.42678 18.5302 8.71967C18.8231 9.01256 18.8231 9.48732 18.5302 9.78022L12.5302 15.7802C12.2373 16.0731 11.7626 16.0731 11.4697 15.7802L5.46967 9.78022C5.17678 9.48732 5.17678 9.01256 5.46967 8.71967C5.76256 8.42678 6.23732 8.42678 6.53022 8.71967L11.9999 14.1894L17.4697 8.71967Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default ChevronDownIcon;
